import { useAuth } from "../contexts/Auth.context"
import { useHistory } from "react-router-dom"

export default function BrandLogo({ light, center }) {
    const history = useHistory()
    const { authenticatedUser: user } = useAuth()

    return (
        <div
            onClick={() => history.push(user ? "/dashboard" : "/")}
            className={`py-6 text-2xl sm:text-3xl font-bold cursor-pointer ${center && "text-center"} ${light ? "text-indigo-300" : "text-indigo-400"}`}
        >
            cash<span className={light ? "text-white" : "text-indigo-600"}>bar°</span>
        </div>
    )
}